import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import DeletesToast from '@/components/toasts/DeletesToast';
import actions from '../constants';
import TokenExpiredToast from '../components/TokenExpiredToast';

export function* disableTokenToast({ items }) {
  yield call(showToast, <TokenExpiredToast items={items} />);
}

export function* destroyTokenToast({ items }) {
  yield call(showToast, <DeletesToast items={items} />);
}

export function* disableTokenErrorToast({ items }) {
  yield call(showToast, <ErrorsToast operation="actions.disable" errors={items} />);
}

export function* destroyTokenErrorToast({ items }) {
  yield call(showToast, <ErrorsToast operation="actions.delete" errors={items} />);
}

export default function* tokensToasts() {
  yield takeEvery(actions.DESTROY_TOKEN, destroyTokenToast);
  yield takeEvery(actions.DISABLE_TOKEN_SUCCESS, disableTokenToast);
  yield takeEvery(actions.DISABLE_TOKEN_ERROR, disableTokenErrorToast);
  yield takeEvery(actions.DESTROY_TOKEN_ERROR, destroyTokenErrorToast);
}
